import { useMemo } from 'react';
import { ColumnDef, createColumnHelper, SortingFn } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { ChildDto } from '@families-link/shared';
import { tableCellTypographyOverflowStyles } from '../../../_core/styles';
import { Typography } from '@mui/material';
import { mergeSx } from 'merge-sx';
const helper = createColumnHelper<ChildDto & { createdAt: string; updatedAt: string }>();

export function useStudentsTableColumns(): ColumnDef<ChildDto, string>[] {
	const [t] = useTranslation();

	const result = useMemo(
		() => [
			helper.accessor('studentId', {
				header: 'Student ID',
				meta: {
					flex: 1,
				},
				enableSorting: false,
				cell: ({ row }) => (
					<Typography sx={mergeSx(tableCellTypographyOverflowStyles, {fontSize: '12px'})} data-overflow="true">
						{row.original.studentId}
					</Typography>
				),
			}) as ColumnDef<ChildDto, string>,
			helper.accessor('name', {
				header: 'Student Name',
				meta: {
					flex: 1,
				},
				enableSorting: false,
				cell: ({ row }) => (
					<Typography sx={mergeSx(tableCellTypographyOverflowStyles,  {fontSize: '12px'})} data-overflow="true">
						{row.original.name}
					</Typography>
				),
			}) as ColumnDef<ChildDto, string>,
		],
		[t]
	);

	return result;
}
